class Global {

    constructor() {
    }

    getAPI( api ) {
      var apiEndPoint = window.THREE_REACT_APP_GLOBAL.api_endpoint;
      var lang = window.THREE_REACT_APP_GLOBAL.language;

      return apiEndPoint+lang+"/"+api+".json";
    }

    byClassNameAddClass(elem, className) {
      var d = document.getElementsByClassName(elem);
      for(let i = 0; i < d.length; i++){
          d[i].className += " "+className;
      }
    }

    byClassNameRemoveClass(elem, className) {
      var d = document.getElementsByClassName(elem);
      for(let i = 0; i < d.length; i++){
        var currentClasses = d[i].className;
        var res = currentClasses.replace(className, "");
        d[i].className = res;
      }
    }

    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  
    setChunkArray(myArray, chunk_size) {
      var index = 0;
      var arrayLength = myArray.length;
      var tempArray = [];

      for (index = 0; index < arrayLength; index += chunk_size) {
          var myChunk = myArray.slice(index, index+chunk_size);
          tempArray.push(myChunk);
      }

      return tempArray;
    }

    render() {
      return false;
    }

}

export default (new Global);
